"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

module.exports = PropertyName;

var SyntaxUnit = require("../util/SyntaxUnit");

var Parser = require("./Parser");
/**
 * Represents a selector combinator (whitespace, +, >).
 * @namespace parserlib.css
 * @class PropertyName
 * @extends parserlib.util.SyntaxUnit
 * @constructor
 * @param {String} text The text representation of the unit.
 * @param {String} hack The type of IE hack applied ("*", "_", or null).
 * @param {int} line The line of text on which the unit resides.
 * @param {int} col The column of text on which the unit resides.
 */


function PropertyName(text, hack, line, col) {
  SyntaxUnit.call(this, text, line, col, Parser.PROPERTY_NAME_TYPE);
  /**
   * The type of IE hack applied ("*", "_", or null).
   * @type String
   * @property hack
   */

  this.hack = hack;
}

PropertyName.prototype = new SyntaxUnit();
PropertyName.prototype.constructor = PropertyName;

PropertyName.prototype.toString = function () {
  return (this.hack ? this.hack : "") + this.text;
};